import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: { label: string; to: string };
}

export default function EmptyState({
  icon = "ri-search-line",
  title,
  description = "Try adjusting your filters or searching for something else.",
  action,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-background-100 text-foreground-500">
        <i className={`${icon} text-2xl`}></i>
      </span>
      <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{title}</h3>
      <p className="mt-2 max-w-md text-sm text-foreground-600 leading-relaxed">{description}</p>
      {action && (
        <Link
          to={action.to}
          className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 hover:bg-primary-600 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i>
          {action.label}
        </Link>
      )}
    </div>
  );
}